import { useState, useEffect, useCallback } from 'react';
import { Delete, Check } from 'lucide-react';

export const PinKeypad = ({ length = 4, onComplete, onChange, error }) => {
    const [pin, setPin] = useState('');

    const setSafe = useCallback((next) => {
        setPin(next);
        onChange?.(next);
        if (next.length === length) onComplete?.(next);
    }, [length, onChange, onComplete]);

    const press = (d) => {
        if (pin.length >= length) return;
        setSafe(pin + d);
    };
    const back = () => setSafe(pin.slice(0, -1));
    const clear = () => setSafe('');

    useEffect(() => {
        const handler = (e) => {
            if (e.key >= '0' && e.key <= '9') press(e.key);
            else if (e.key === 'Backspace') back();
            else if (e.key === 'Enter' && pin.length === length) onComplete?.(pin);
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [pin]); // eslint-disable-line

    return (
        <div className="w-full max-w-xs mx-auto">
            <div className="flex items-center justify-center gap-3 mb-6">
                {[...Array(length)].map((_, i) => (
                    <div key={i}
                         className={`h-4 w-4 rounded-full border-2 transition-all ${i < pin.length ? 'border-primary bg-primary' : 'border-border bg-transparent'} ${error ? 'border-destructive' : ''}`}
                         data-testid={`pin-dot-${i}`}
                    />
                ))}
            </div>
            {error && <p className="text-center text-sm text-destructive mb-3" role="alert">{error}</p>}
            <div className="grid grid-cols-3 gap-3">
                {[1,2,3,4,5,6,7,8,9].map(n => (
                    <button key={n} type="button" onClick={() => press(String(n))}
                            data-testid={`pin-keypad-key-${n}`}
                            className="h-14 rounded-xl border bg-[hsl(var(--secondary))] text-lg font-semibold hover:bg-[hsl(var(--accent))] transition-colors focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:outline-none">
                        {n}
                    </button>
                ))}
                <button type="button" onClick={clear}
                        className="h-14 rounded-xl border bg-[hsl(var(--secondary))] text-sm hover:bg-[hsl(var(--accent))] transition-colors">C</button>
                <button type="button" onClick={() => press('0')}
                        data-testid="pin-keypad-key-0"
                        className="h-14 rounded-xl border bg-[hsl(var(--secondary))] text-lg font-semibold hover:bg-[hsl(var(--accent))] transition-colors">0</button>
                <button type="button" onClick={back}
                        data-testid="pin-keypad-back"
                        className="h-14 rounded-xl border bg-[hsl(var(--secondary))] hover:bg-[hsl(var(--accent))] transition-colors flex items-center justify-center">
                    <Delete className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};
